// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".presets[data-v-21c7003c]{display:flex;flex-flow:wrap}", ""]);
// Exports
module.exports = exports;
